/**
 * useIsMobile - 移动端检测 Hook
 *
 * 🎯 功能：
 * 1. 检测当前设备是否为移动端（屏幕宽度 <= 768px）
 * 2. 监听窗口大小变化，实时更新状态
 * 3. 支持服务端渲染（SSR）
 *
 * 📱 使用场景：
 * - 响应式布局适配
 * - 移动端/桌面端差异化交互
 * - 条件渲染移动端专属组件
 *
 * @param breakpoint 断点值，默认为 768px
 * @returns {boolean} 是否为移动端
 */

import { useState, useEffect } from 'react';

export function useIsMobile(breakpoint: number = 768): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // 只在浏览器环境执行
    if (typeof window === 'undefined') {
      return;
    }

    // 检测是否为移动端
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    // 初始检测
    checkMobile();

    // 监听窗口大小变化
    window.addEventListener('resize', checkMobile);

    // 清理事件监听器
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [breakpoint]);

  return isMobile;
}
